export { renderBadge_unstable as renderCounterBadge } from '@fluentui/react-badge';
